import type { ReactNode } from "react";
import { cn } from "~/lib/utils";

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  body?: string;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ icon, title, body, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-1.5 px-6 py-7 text-center",
        className,
      )}
    >
      {icon && (
        <div className="text-text-faint mb-1 flex size-9 items-center justify-center rounded-full bg-muted">
          {icon}
        </div>
      )}
      <p className="text-[14px] font-medium tracking-[-0.005em]">{title}</p>
      {body && <p className="text-text-faint max-w-sm text-[13px]">{body}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
